import { useTranslation } from "react-i18next";

import { lightTap } from "../../../lib/input/haptic";
import { INTRO_PAGE_URL } from "../../../lib/intro_page";
import { useUIStore } from "../../../store/ui";

/**
 * Settings and the product introduction, on the two screens a player
 * sees before a table: the login and the lobby. Language and sound are
 * as much a question before signing in as after, and the introduction
 * is for the person deciding whether to sign up at all.
 *
 * The sheet itself is mounted by the route above both screens
 * (`EntrySettingsSheet`); this only opens it.
 */
export function EntryLinks(): JSX.Element {
  const { t } = useTranslation();
  const openSettings = useUIStore((s) => s.setSettingsPanelOpen);
  return (
    <nav className="entry-links" aria-label={t("entry.links_aria")}>
      <button
        type="button"
        className="entry-links__item"
        onClick={() => {
          lightTap();
          openSettings(true);
        }}
      >
        {/* The gear is decoration: the accessible name stays the word. */}
        <span className="entry-links__icon" aria-hidden="true">
          ⚙️
        </span>
        <span className="entry-links__label">{t("entry.settings")}</span>
      </button>
      {/* The same tab, so the way back is the one the player already
       *  knows. A new tab left no history behind it — Safari's back did
       *  nothing — and a home-screen install has no tab bar to return
       *  through at all. Coming back reloads the app, and the session
       *  restores from the device on boot. The page carries its own link
       *  back as well, for the install that has no back button. */}
      <a className="entry-links__item" href={INTRO_PAGE_URL}>
        <span className="entry-links__label">{t("entry.about")}</span>
      </a>
    </nav>
  );
}
